var stateReqData = {
  /*labels: [
    "Legal for Consumer Use/Posession",
    "Other Restrictions*"
  ],
  states: {*/
    alabama: {
      name: "Alabama",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/alabama"
    },
    alaska: {
      name: "Alaska",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/alaska"
    },
    arizona: {
      name: "Arizona",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/arizona"
    },
    arkansas: {
      name: "Arkansas",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/arkansas"
    },
    california: {
      name: "California",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/california"
    },
    colorado: {
      name: "Colorado",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/colorado"
    },
    connecticut: {
      name: "Connecticut",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/connecticut"
    },
    delaware: {
      name: "Delaware",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/delaware"
    },
    district_columbia: {
      name: "District of Columbia",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/district-of-columbia"
    },
    florida: {
      name: "Florida",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/florida"
    },
    georgia: {
      name: "Georgia",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/georgia"
    },
    hawaii: {
      name: "Hawaii",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/hawaii"
    },
    idaho: {
      name: "Idaho",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/idaho"
    },
    illinois: {
      name: "Illinois",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/illinois"
    },
    indiana: {
      name: "Indiana",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/indiana"
    },
    iowa: {
      name: "Iowa",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/iowa"
    },
    kansas: {
      name: "Kansas",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/kansas"
    },
    kentucky: {
      name: "Kentucky",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/kentucky"
    },
    louisiana: {
      name: "Louisiana",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/louisiana"
    },
    maine: {
      name: "Maine",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/maine"
    },
    maryland: {
      name: "Maryland",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/maryland"
    },
    massachusetts: {
      name: "Massachusetts",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/massachusetts"
    },
    michigan: {
      name: "Michigan",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/michigan"
    },
    minnesota: {
      name: "Minnesota",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/minnesota"
    },
    mississippi: {
      name: "Mississippi",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/mississippi"
    },
    missouri: {
      name: "Missouri",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/missouri"
    },
    montana: {
      name: "Montana",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/montana"
    },
    nebraska: {
      name: "Nebraska",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/nebraska"
    },
    nevada: {
      name: "Nevada",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/nevada"
    },
    new_hampshire: {
      name: "New Hampshire",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/new-hampshire"
    },
    new_jersey: {
      name: "New Jersey",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/new-jersey"
    },
    new_mexico: {
      name: "New Mexico",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/new-mexico"
    },
    new_york: {
      name: "New York",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/newyork"
    },
    north_carolina: {
      name: "North Carolina",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/north-carolina"
    },
    north_dakota: {
      name: "North Dakota",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/north-dakota"
    },
    ohio: {
      name: "Ohio",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/ohio"
    },
    oklahoma: {
      name: "Oklahoma",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/oklahoma"
    },
    oregon: {
      name: "Oregon",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/oregon"
    },
    pennsylvania: {
      name: "Pennsylvania",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/pennsylvania"
    },
    puerto_rico: {
      name: "Puerto Rico",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/puerto-rico"
    },
    rhode_island: {
      name: "Rhode Island",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/rhode-island"
    },
    south_carolina: {
      name: "South Carolina",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/south-carolina"
    },
  	south_dakota: {
  	  name: "South Dakota",
  	  values: [
    		{value: true, text: ""},
    		{value: false, text: ""}
  	  ],
      statelink: "/pages/south-dakota"
  	},
    tennessee: {
      name: "Tennessee",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/tennessee"
    },
    texas: {
      name: "Texas",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/texas"
    },
    utah: {
      name: "Utah",
      values: [
        {value: true, text: ""},
        {value: false, text: ""}
      ],
      statelink: "/pages/utah"
    },
    vermont: {
      name: "Vermont",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/vermont"
    },
    virginia: {
      name: "Virginia",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/virginia"
    },
    washington: {
      name: "Washington",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/washington"
    },
    west_virginia: {
      name: "West Virginia",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/west-virginia"
    },
    wisconsin: {
      name: "Wisconsin",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/wisconsin"
    },
    wyoming: {
      name: "Wyoming",
      values: [
        {value: true, text: ""},
        {value: true, text: "Consult with your state and local laws to see what restrictions apply."}
      ],
      statelink: "/pages/wyoming"
    }
  //}
};